import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";

import { TailSpin } from "react-loader-spinner";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import Add_CancellationPolicy from "../../Components/Admin_components/add_CancelationPolicy.js";
import Update_Policy from "../../Components/Admin_components/update_cancellationPolicy.js";
import Delete_Policy from "../../Components/Admin_components/delete_CancellationPolicy.js";
import "../../Api/apiUrls.js";
import {getCancellationPolicy} from "../../Api/apiUrls";


function CancellationPolicy() {
  const [
    modalAdd_CancellationPolicyIsOpen,
    setAdd_CancellationPolicyModalIsOpen,
  ] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [Policy, setPolicy] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [
    modalUpdate_CancellationPolicyIsOpen,
    setUpdate_CancellationPolicyModalIsOpen,
  ] = useState(false);
  const [
    modalDelete_CancellationPolicyIsOpen,
    setDelete_CancellationPolicyIsOpen,
  ] = useState(false);
  // const [selectedUserId, setSelectedUserId] = useState(null);
  const Status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const openAdd_CancellationPolicy = () => {
    closeAddCancellationPolicy();
    setAdd_CancellationPolicyModalIsOpen(true);
  };

  const closeAddCancellationPolicy = () => {
    setAdd_CancellationPolicyModalIsOpen(false);
  };

  const openUpdate_CancellationPolicy = (policyId, Policy) => {
    setSelectedUserId(policyId);
    setSelectedPolicy(Policy);
    closeUpdate_CancellationPolicy();
    setUpdate_CancellationPolicyModalIsOpen(true);
  };

  const closeUpdate_CancellationPolicy = () => {
    setUpdate_CancellationPolicyModalIsOpen(false);
  };
  const openDelete_CancellationPolicy = (policyId) => {
    setSelectedUserId(policyId);
    closeDelete_CancellationPolicy();
    setDelete_CancellationPolicyIsOpen(true);
  };

  const closeDelete_CancellationPolicy = () => {
    setDelete_CancellationPolicyIsOpen(null);
  };

  useEffect(() => {
    fetch(
      `${getCancellationPolicy}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const policy = data.data.CancellationPolicy;
        setPolicy(policy);
        console.log(policy);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div>
      <Header></Header>
      {modalAdd_CancellationPolicyIsOpen && (
        <Add_CancellationPolicy onClose={closeAddCancellationPolicy} />
      )}
      {modalUpdate_CancellationPolicyIsOpen && (
        <Update_Policy
          policyId={selectedUserId}
          onClose={closeUpdate_CancellationPolicy}
        />
      )}
      {modalDelete_CancellationPolicyIsOpen && (
        <Delete_Policy
          policyId={selectedUserId}
          onClose={closeDelete_CancellationPolicy}
        />
      )}
      <main id="main" class="main">
        <div class="pagetitle">
          <h1> Cancellation Policy</h1>
        </div>
        <section class="section">
          <div class="card p-2">
            <div class="parent col-md-12 row mt-2">
              <div class="col-md-6">
                <div class="child">
                  <input
                    id="myInput"
                    type="text"
                    style={{
                      borderRadius: "5px",
                      height: "35px",
                      padding: "10px",
                      border: "1px solid lightgrey ",
                    }}
                    placeholder="Search..."
                  />
                </div>
                <div class="child ml-2">
                  <Select options={Status} placeholder="Select Status"></Select>
                </div>
              </div>
              <div class="col-md-6" style={{ textAlign: "right" }}>
                <div class="child">
                  <a>
                    <button
                      id="btnNewUser"
                      type="button"
                      data-toggle="modal"
                      data-target="#modalAdd"
                      class="btn-round"
                      onClick={openAdd_CancellationPolicy}
                    >
                      <i class="bi bi-person-add"></i> Add Cancellation Policy
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
            ></div>
            {isLoading === true ? (
              <div
                style={{
                  marginTop: "50px",
                  display: "flex",
                  marginLeft: "50%",
                }}
              >
                <TailSpin color="black" width={50} />
              </div>
            ) : Policy.length > 0 ? (
              <table class="table table-striped ">
                <thead>
                  <tr>
                    <th scope="col">Sr.No</th>
                    <th scope="col">Policy</th>

                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Policy.map((Policy, index) => (
                    <tr key={Policy.id}>
                      <th scope="row">{index + 1}</th>
                      <td>{Policy.policy_text || "-"}</td>

                      <td>
                        <div className="social-links mt-2">
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openUpdate_CancellationPolicy(
                                Policy.id,
                                Policy.policy_text
                              )
                            }
                          >
                            <i class="bi bi-pencil"></i>
                          </a>
                          &nbsp;&nbsp;
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openDelete_CancellationPolicy(Policy.id)
                            }
                          >
                            <i class="bi bi-trash3"></i>
                          </a>
                          &nbsp;
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <h3 style={{ textAlign: "center" }}> No data available </h3>
            )}
            {modalUpdate_CancellationPolicyIsOpen && (
              <Update_Policy
                policyId={selectedUserId}
                Policy={selectedPolicy}
                onClose={closeUpdate_CancellationPolicy}
              />
            )}
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default CancellationPolicy;
